import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { AddonInterface } from "../../../../store/mods_factory/addonsSlice";
import { fetchUser } from "../../../../actions/mods_factory/usersActions";
import { selectUserById } from "../../../../store/mods_factory/usersSlice";

import { RightSidebar } from "../../../_partials/Layout";
import Meta from "../../Users/_partials/_Meta";

const _SidebarShow = ({ addon }: { addon: AddonInterface | undefined }) => {
  const dispatch  = useAppDispatch();
  const user      = useAppSelector(state => addon?.user_id ? selectUserById(state, addon?.user_id) : undefined);

  useEffect(() => {
    if (addon?.user_id) {
      dispatch(fetchUser(addon?.user_id));
    }
  }, [addon, dispatch]);

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      <h6 className="v-content-label o-sm v-mt-25">User</h6>
      {<Meta user={user} />}
    </RightSidebar>
  )
}

export default _SidebarShow;
